import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styles from './AnalyticsPdfLinkDetails.module.css'

const INTERNAL_LINK_PREFIX = 'internal:page-'

const isInternalLink = (url) => typeof url === 'string' && url.startsWith(INTERNAL_LINK_PREFIX)

const getLinkLabel = (url) => (isInternalLink(url) ? `Jump to page ${url.slice(INTERNAL_LINK_PREFIX.length)}` : url)

const AnalyticsPdfLinkRow = ({ link }) => (
  <Row className={`${styles.linkRow} py-3 border-bottom g-0`}>
    <Col xs={12} lg={8} className="mb-2 mb-lg-0">
      {isInternalLink(link.url) ? (
        <span className={styles.linkUrl}>{getLinkLabel(link.url)}</span>
      ) : (
        <a href={link.url} target="_blank" rel="noopener noreferrer" className={styles.linkUrl}>
          {link.url}
        </a>
      )}
    </Col>
    <Col xs={12} lg={4}>
      <span className="d-inline d-lg-none text-muted me-2">Clicks:</span>
      <span className="fw-medium">{link.clicks}</span>
    </Col>
  </Row>
)

export default AnalyticsPdfLinkRow
